import { Component, OnInit } from '@angular/core';
import { NavigationConstant } from '@constant/navigation.constant';
import { Router } from '@angular/router';
import { BncStorage } from '@shared/storage/bnc.storage';

@Component({
  selector: 'app-payment-result-bnc',
  templateUrl: './payment-result-bnc.component.html'
})
export class PaymentResultBncComponent implements OnInit {
  imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/success.png';
  paymentResult = 'Success';
  isSuccess = true;

  failedReason;

  invoiceNumber: string;
  transactionDate: string;
  merchantName: string;
  transactionAmount: string;
  phoneNumber: string;
  transactionId: string;
  customerName: string;
  vaNumber: number;
  billingNumber: string;

  constructor(
    private router: Router,
    private storage: BncStorage,
  ) { }

  ngOnInit(): void {
    console.log('init payment result bnc')
    if (this.storage.data == null) {
      this.router.navigate([NavigationConstant.BNC_INQUIRY]);
    }

      var responseNotification = localStorage.getItem('bnc_result_notification_success');
      let jsonResponsePaymentNotification = JSON.parse(responseNotification);
      this.transactionAmount = jsonResponsePaymentNotification.amount;
      this.customerName = jsonResponsePaymentNotification.customer_name;
      this.vaNumber = jsonResponsePaymentNotification.virtual_account;

  }

    goToInquiry() {
        this.router.navigate([NavigationConstant.BNC_INQUIRY]);
    }
}
